export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative bg-surface">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 py-24 md:py-40 grid grid-cols-12 gap-6 md:gap-10">
        <div className="col-span-12 md:col-span-5 reveal">
          <div className="relative aspect-[3/4] overflow-hidden rounded-sm bg-bg">
            <img
              src="/uploads/2025/01/jojo.jpg"
              alt="Portrait of Joanna Bedevian"
              data-testid="about-portrait"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="mt-4 flex items-center justify-between text-xs tracking-[0.28em] uppercase text-sub">
            <span>Joanna Bedevian</span>
            <span>Bristol · UK</span>
          </div>

          <div className="mt-10">
            <div className="kicker">Skills</div>
            <div className="mt-4 flex flex-wrap gap-2">
              {['SketchUp', 'AutoCAD', 'Twinmotion', 'Rhino', 'Photoshop', 'InDesign', 'Illustrator'].map((s) => (
                <span
                  key={s}
                  className="inline-flex items-center px-3 py-1.5 rounded-full border border-ink/20 text-[11px] tracking-[0.18em] uppercase text-ink/80 bg-bg/60"
                >
                  {s}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="col-span-12 md:col-span-6 md:col-start-7 md:pt-10 reveal">
          <span className="kicker">About</span>
          <h2 className="font-display font-light text-ink mt-3 leading-[0.98] tracking-tight text-[clamp(2.6rem,6vw,5.5rem)]">
            Precision in every detail.<br />
            <span className="italic text-crimson">Elegance</span> in every room.
          </h2>

          <div className="mt-8 space-y-5 text-base md:text-lg leading-relaxed text-sub max-w-xl">
            <p>
              My name is Joanna Bedevian, and this is a showcase of the projects I have completed
              during my interior design degree — process, materials, and final work, side by side.
            </p>
            <p>
              I work in the slow space between architecture and craft. Each room I design begins as
              a sketch, becomes a model, and ends as a series of material decisions: how a glass
              edge meets timber, how light folds into stone, how a person rests inside a volume.
            </p>
            <p>
              Outside of interiors I make hand-blown glass sculptures that often inform the
              language of my spaces — soft refractions, sharp edges, quiet drama.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6 max-w-md">
            <div>
              <div className="font-display text-4xl text-ink tabular">3+</div>
              <div className="text-[11px] tracking-[0.28em] uppercase text-sub mt-1">Projects</div>
            </div>
            <div>
              <div className="font-display text-4xl text-ink tabular">11</div>
              <div className="text-[11px] tracking-[0.28em] uppercase text-sub mt-1">Glass works</div>
            </div>
            <div>
              <div className="font-display text-4xl text-ink tabular">2025</div>
              <div className="text-[11px] tracking-[0.28em] uppercase text-sub mt-1">Folio year</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
